import { InstanceTypeOf } from '@/type-utils';
import { errorFactory } from '@/utils/error-utils';
import { InvalidArgumentError } from '@/utils/errors';

export const { CannotShipToUSTerritoryError } = errorFactory(
  'CannotShipToUSTerritoryError',
  InvalidArgumentError
);

/**
 * Error to use when the customer enters a US territory as their shipping address
 * and shipping to US territories is disabled.
 */
export type CannotShipToUSTerritoryError = InstanceTypeOf<
  typeof CannotShipToUSTerritoryError
>;
